import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Cabang", -1)
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Penanggung Jawab", -1)
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_21 = { class: "col-lg-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kabupaten/ Kota", -1)
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_26 = { class: "col-lg-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat", -1)
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Keterangan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "Detail " + _toDisplayString(_ctx.detail.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/branch')))
          }, " Kembali ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.name) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Field, {
              type: "text",
              name: "picBranch",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.picBranch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.picBranch) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.email) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_Field, {
              type: "text",
              name: "picBranch",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.phone) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.province,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.address.province) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Field, {
              type: "text",
              name: "picBranch",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.city,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.address.city) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.regency,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.address.regency) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "note",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.address.detail) = $event)),
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.detail.address.detail]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "note",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detail.note) = $event)),
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.detail.note]
            ])
          ])
        ])
      ])
    ])
  ], 2))
}